import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
export default normalize(function (options) {
  var selector = options.selector,
      duration = options.duration,
      success = options.success,
      fail = options.fail,
      complete = options.complete;
  var scrollTop = options.scrollTop;
  var rootElement = document.documentElement;
  var top = rootElement.scrollTop;

  if (scrollTop == null) {
    if (!selector) {
      var msg = '`scrollTop` or `selector` is required';
      fail(msg);
      complete(msg);
      return;
    }

    var ele = document.querySelector(selector);

    if (!ele) {
      var _msg = "The element cannot be found by the selector `" + selector + "`";

      fail(_msg);
      complete(_msg);
      return;
    }

    scrollTop = top + ele.getBoundingClientRect().top;
  } // Already at the target position


  if (top === scrollTop) {
    success('OK');
    complete('OK');
    return;
  } // Scroll immediately


  if (Number(duration) === 0) {
    rootElement.scrollTop = scrollTop;
    success('OK');
    complete('OK');
    return;
  }

  var maxScrollTop = rootElement.scrollHeight - rootElement.clientHeight;

  if (scrollTop < 0) {
    scrollTop = 0;
  } else if (scrollTop > maxScrollTop) {
    scrollTop = maxScrollTop;
  } // Scroll distance per 1ms


  var speed = (scrollTop - top) / duration;

  var handleScroll = function handleScroll(startTime) {
    requestAnimationFrame(function () {
      var cost = Date.now() - startTime;

      if (cost < 5) {
        // throttle
        handleScroll(startTime);
        return;
      }

      top = rootElement.scrollTop;
      var nextTop = top + cost * speed;

      if (speed > 0 && nextTop > scrollTop || speed < 0 && nextTop < scrollTop) {
        nextTop = scrollTop;
      }

      rootElement.scrollTop = nextTop;

      if (nextTop === scrollTop) {
        success('OK');
        complete('OK');
      } else {
        handleScroll(Date.now());
      }
    });
  }; // start scrolling


  handleScroll(Date.now());
}, CONTAINER_NAME.WEB);